// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"_1zXPG1zQL9HrtfiurgJI2j","avatarPlaceholder":"_2Wu1feyarDvVXiWXtbRwqq"};